function Article1() {
    return<p>En cours de rédaction...</p>
}

export default Article1